import gCard from "@/components/g-card/g-card.vue"
import gForm from "@/components/g-form/g-form.vue"
import gSteps from "@/components/g-steps/g-steps.vue";
import gButton from '@/components/g-button/g-button.vue'
import gCardResumo from '@/components/g-card-resumo/g-card-resumo.vue'
import gMenuSidebar from "@/components/g-menu-sidebar/g-menu-sidebar.vue";

const name = 'GerarNovoPedido'

export default {

  name,

  components: {
    'g-card': gCard,
    'g-form': gForm,
    'g-button' : gButton,
    'g-steps' : gSteps,
    'g-card-resumo' : gCardResumo,
    'g-menu-sidebar': gMenuSidebar
   },

  props: { },

  mounted () {
    this.pedidoId = this.$route.params.id
   },

  updated () { },

  data () {
    return {
        resumoobj: {},
        resumoCarregamento: [],
        MascaraCnpj: {},
        steps: 0,
        items: [
            {
                label: '',
                icon: "pi pi-user",
                to: `/gerar-novo-pedido/${this.$route.params.id}/info-cliente-pedido`,
            },
            {
                label: '',
                icon: "pi pi-car",
                to: `/gerar-novo-pedido/${this.$route.params.id}/info-frete-pedido`,
            },
            {
                label: '',
                icon: "pi pi-box",
                to: `/gerar-novo-pedido/${this.$route.params.id}/produto-em-carregamento-pedido`,
            },
            {
                label: '',
                icon: "pi pi-arrows-v",
                to: `/gerar-novo-pedido/${this.$route.params.id}/carac-produto-pedido`,
            }
        ],
        pedidoId: '',
        rotaAtual: ''
    };
  },

  methods: {
    verificarTabs (index) {
      this.steps = index
      if (index == 0 || index == 1) {
        this.pupulaResumoLateralStep0e1()
      }
      else if (index == 2) {
        this.pupulaResumoLateralStep2()
      }
      else if (index == 3) {
        this.pupulaResumoLateralStep3()
        this.pupulaQuantidadeDataCarregResumoLateral()
      }
    },

    pupulaResumoLateralStep0e1() {
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `Pedido/GetPedidoResumoLateral/${this.$route.params.id}`,
      })
      .then((response) => {
        this.resumoobj = response.data.data;
        this.MascaraCnpj = response.data.data.cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,"$1.$2.$3/$4-$5")
      })
        .catch(() => {
      });
    },

    pupulaResumoLateralStep2() {
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `Pedido/GetPedidoResumoLateralEntrega/${this.pedidoId}`,
      })
      .then((response) => {
        this.resumoobj = response.data.data;
        this.MascaraCnpj = response.data.data.cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,"$1.$2.$3/$4-$5")
      })
        .catch(() => {
      });
    },

    pupulaResumoLateralStep3() {
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `Pedido/GetPedidoResumoLateralProduto/${this.pedidoId}`,
      })
      .then((response) => {
        if(response.data.code == 200){
          this.resumoobj = response.data.data;
          this.MascaraCnpj = response.data.data.cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,"$1.$2.$3/$4-$5")
        }
      })
      .catch(() => {
      });
    },

    pupulaQuantidadeDataCarregResumoLateral() {
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `Pedido/GetQuantidadeDataCarregamentoResumoLateral/${this.pedidoId}`,
      })
      .then((response) => {
        this.resumoCarregamento = response.data.data;
      })
      .catch(() => {
      });
    },
  },

  computed: { },

};